module.exports = __webpack_public_path__ + "static/Mathias-Verraes.dee76b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Mathias-Verraes.jpg
// module id = 117
// module chunks = 55433589350533 66822608004007